// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CreditCardFilledSvg from "@ant-design/icons-svg/es/asn/CreditCardFilled";
import AntdIcon from '../components/AntdIcon';

var CreditCardFilled = function CreditCardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardFilledSvg
  }));
};

CreditCardFilled.displayName = 'CreditCardFilled';
export default React.forwardRef(CreditCardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CreditCardFilled.js
// module id = 885
// module chunks = 0